module.exports = __webpack_public_path__ + "static/media/dart.6c0801f1.svg";